import auth from '@/request/auth'

export default {
  methods: {
    $checkAuth(alreadyLogin, afterLogin) {
      return auth.ensure({
        method: 'replace',
        callback: () => {
          if (afterLogin) {
            afterLogin()
          }

          return Promise.reject({message: '阻止alreadyLogin执行'})
        }
      }).then(alreadyLogin)
    },
    $getAuth() {
      return auth.get()
    },
    $ensureAuth() {
      return auth.ensure()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loginGetInfo.js